/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LandingConfiguration
 */
export interface LandingConfiguration {
	/**
	 *
	 * @type {boolean}
	 * @memberof LandingConfiguration
	 */
	isAdditionalInforamtionsSectionVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof LandingConfiguration
	 */
	isTermsAndConditionsChecked?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof LandingConfiguration
	 */
	isAdditionalHeaderContentVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof LandingConfiguration
	 */
	isAcceptPrivacyDataOnLinkClickEnabled?: boolean | null;
}

/**
 * Check if a given object implements the LandingConfiguration interface.
 */
export function instanceOfLandingConfiguration(value: object): value is LandingConfiguration {
	return true;
}

export function LandingConfigurationFromJSON(json: any): LandingConfiguration {
	return LandingConfigurationFromJSONTyped(json, false);
}

export function LandingConfigurationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): LandingConfiguration {
	if (json == null) {
		return json;
	}
	return {
		isAdditionalInforamtionsSectionVisible:
			json['isAdditionalInforamtionsSectionVisible'] == null
				? undefined
				: json['isAdditionalInforamtionsSectionVisible'],
		isTermsAndConditionsChecked:
			json['isTermsAndConditionsChecked'] == null ? undefined : json['isTermsAndConditionsChecked'],
		isAdditionalHeaderContentVisible:
			json['isAdditionalHeaderContentVisible'] == null
				? undefined
				: json['isAdditionalHeaderContentVisible'],
		isAcceptPrivacyDataOnLinkClickEnabled:
			json['isAcceptPrivacyDataOnLinkClickEnabled'] == null
				? undefined
				: json['isAcceptPrivacyDataOnLinkClickEnabled'],
	};
}

export function LandingConfigurationToJSON(json: any): LandingConfiguration {
	return LandingConfigurationToJSONTyped(json, false);
}

export function LandingConfigurationToJSONTyped(
	value?: LandingConfiguration | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		isAdditionalInforamtionsSectionVisible: value['isAdditionalInforamtionsSectionVisible'],
		isTermsAndConditionsChecked: value['isTermsAndConditionsChecked'],
		isAdditionalHeaderContentVisible: value['isAdditionalHeaderContentVisible'],
		isAcceptPrivacyDataOnLinkClickEnabled: value['isAcceptPrivacyDataOnLinkClickEnabled'],
	};
}
